import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X, Plus } from "lucide-react";
import { useLang, CONTACT } from "../../translations";

const WhatsAppIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z"/>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.02c-1.53 0-3.03-.41-4.34-1.19l-.31-.18-3.11.82.83-3.03-.2-.32a8.2 8.2 0 01-1.26-4.39c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 012.41 5.82c0 4.54-3.69 8.23-8.23 8.23z"/>
  </svg>
);

export const FloatingWidget = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 z-[99] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <>
            <motion.a
              data-testid="widget-whatsapp"
              href={`https://wa.me/${CONTACT.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 10, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.9 }}
              className="flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg"
            >
              <WhatsAppIcon /> <span className="text-sm font-medium">{t.widget.whatsapp}</span>
            </motion.a>
            <motion.a
              data-testid="widget-call"
              href={`tel:${CONTACT.phoneRaw}`}
              initial={{ opacity: 0, y: 10, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.9 }}
              transition={{ delay: 0.05 }}
              className="flex items-center gap-3 rounded-full bg-ink text-cream pl-4 pr-5 py-3 shadow-lg"
            >
              <Phone size={20} /> <span className="text-sm font-medium">{t.widget.call}</span>
            </motion.a>
          </>
        )}
      </AnimatePresence>

      <button
        data-testid="widget-toggle"
        onClick={() => setOpen((o) => !o)}
        className="relative h-14 w-14 rounded-full bg-sage text-cream flex items-center justify-center shadow-xl hover:bg-sage-dark transition-colors duration-300"
      >
        {!open && <span className="absolute inset-0 rounded-full bg-sage animate-ping opacity-40" />}
        <span className="relative">{open ? <X size={24} /> : <Plus size={24} />}</span>
      </button>
    </div>
  );
};
